module.exports = __webpack_public_path__ + "img/re-swapp-staff-icon.8ad9b347.png";